import React, { useRef } from 'react';
import { Checkbox } from 'antd';
import PeriodRangePicker from './PeriodRangePicker';
import { useDisableMapEvents } from '../hooks/useDisableMapEvents';

function SectionTitle({ children }) {
  return (
    <div style={{ fontWeight: 'bold', marginTop: 8, marginBottom: 6 }}>
      {children}
    </div>
  );
}

export default function MapEventsFilterMenu({
  showComplaints,
  showIncidents,
  filterComplaintsOpen,
  filterIncidentsOpen,

  complaintFilter,
  setComplaintFilter,
  complaintsRange,
  complaintPeriodPickerRef,

  incidentFilter,
  setIncidentFilter,
  incidentsRange,
  incidentPeriodPickerRef,

}) {
  const ref = useRef(null);
  useDisableMapEvents(ref);

  return (
    <div
      ref={ref}
      className="map-card map-card-compact"
      style={{
        minWidth: 260
      }}
    >
      {filterComplaintsOpen && showComplaints && (
        <div className="event-filter-section">
          <div className="map-card-title">
            Complaint filters
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Checkbox
              checked={complaintFilter.status0}
              onChange={e =>
                setComplaintFilter({ ...complaintFilter, status0: e.target.checked })
              }
            >
              Pending
            </Checkbox>
            <Checkbox
              checked={complaintFilter.status1}
              onChange={e =>
                setComplaintFilter({ ...complaintFilter, status1: e.target.checked })
              }
            >
              Resolved
            </Checkbox>
          </div>
          <div style={{ marginTop: 12 }}>
            <PeriodRangePicker
              ref={complaintPeriodPickerRef}
              value={complaintsRange.dateRange}
              onChange={complaintsRange.setDateRange}
              showCustom={complaintsRange.showCustom}
              setShowCustom={complaintsRange.setShowCustom}
              setPreset={complaintsRange.setPreset}
              selectedPreset={complaintsRange.selectedPreset}
              selectedLabel={complaintsRange.selectedLabel}
              presetDefs={complaintsRange.presetDefs}
              width="100%"
            />
          </div>
        </div>
      )}

      {filterIncidentsOpen && showIncidents && (
        <div className="event-filter-section">
          <div className="map-card-title">
            Incident filters
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Checkbox
              checked={incidentFilter.status0}
              onChange={e =>
                setIncidentFilter({ ...incidentFilter, status0: e.target.checked })
              }
            >
              Pending
            </Checkbox>
            <Checkbox
              checked={incidentFilter.status1}
              onChange={e =>
                setIncidentFilter({ ...incidentFilter, status1: e.target.checked })
              }
            >
              Resolved
            </Checkbox>
          </div>

          <div style={{ marginTop: 12 }}>
            <PeriodRangePicker
              ref={incidentPeriodPickerRef}
              value={incidentsRange.dateRange}
              onChange={incidentsRange.setDateRange}
              showCustom={incidentsRange.showCustom}
              setShowCustom={incidentsRange.setShowCustom}
              setPreset={incidentsRange.setPreset}
              selectedPreset={incidentsRange.selectedPreset}
              selectedLabel={incidentsRange.selectedLabel}
              presetDefs={incidentsRange.presetDefs}
              width="100%"
            />
          </div>
        </div>
      )}
    </div>
  );
}
